module.exports = __webpack_public_path__ + "img/horizontal_3_6_0.9fba869c.png";